export function App() {
  return (
    <main style={{ fontFamily: 'sans-serif', padding: '2rem', maxWidth: 600 }}>
      <h1>NBA GM Game — Hello World</h1>
      <p>Phase 0 deployment check.</p>
    </main>
  );
}
